import RecordItem from './RecordItem';

export default RecordItem;
